import { createContext } from 'react'
import styles from './styles-context.module.scss'
import { useTranslation } from 'react-i18next'
import BupSpinner from '@BUP/components/Loading/Spinner'
import AlertComponent from '@BUP/components/Generics/Alert'
import { useGetCurrentSociogram } from '@BUP/hooks/Sociogram/useGetCurrentSociogram'
import ButtonComponent from '@BUP/components/Generics/Buttons/button-component'
import { ReloadOutlined } from '@ant-design/icons'

export const CurrentSociogramContext = createContext()

export const CurrentSociogramContextProvider = ({ children }) => {
  const i18n = useTranslation()
  const {
    isLoadingCurrentSociogram,
    isFetchingCurrentSociogram,
    dataCurrentSociogram,
    errorCurrentSociogram,
    getData: getCurrentSociogram
  } = useGetCurrentSociogram()

  if (isLoadingCurrentSociogram || isFetchingCurrentSociogram) {
    return <BupSpinner size='large' />
  }

  if (errorCurrentSociogram || !dataCurrentSociogram || Object.keys(dataCurrentSociogram).length === 0) {
    return (
      <div className={styles.error_wrapper}>
        <AlertComponent
          message={i18n.t('common.resources.sociogram.actions.read.failure', { context: 'current' })}
          type='error'
        />
        <ButtonComponent buttonText={i18n.t('common.resources.sociogram.actions.reload')} icon={<ReloadOutlined />} onClick={getCurrentSociogram} />
      </div>
    )
  }

  return (
    <CurrentSociogramContext.Provider
      value={{ getCurrentSociogram, dataCurrentSociogram }}
    >
      {children}
    </CurrentSociogramContext.Provider>
  )
}
